import { Budget, Project, Margin, AssemblyCosts, Offer } from '../interfaces/index';
import { AclUser } from '../../interfaces/app-user';

export class BudgetModel implements Budget {

    id: string;
    budgetId: string;
    budgetNr: string;
    author: Partial<AclUser>;
    assignee: Partial<AclUser>;
    category: string;
    clientId: string;
    creation: Date;
    description: string;
    tags: string[];
    status: string;
    prosperworks?: any;
    companyInfo?: any;
    offerUrl?: string;
    driveFolderId?: string;
    project?: Project;
    margin?: Margin;
    assemblyCosts?: AssemblyCosts;
    offer?: Offer;
    modifiedBy?: Partial<AclUser>;
    modifiedOn?: Date;
    costSummary?: any;
    export?: any;
    exportBudget?: any;
    companyName?: any;
    filter?: string[];


    static isEditable(budget: Budget) {
        // if (budget.export) {
        //     return false;
        // }
        if (['closed', 'archived', 'new'].indexOf(budget.status) !== -1) {
            return false;
        } else {
            return true;
        }
    }

}



// WEBPACK FOOTER //
// ./src/app/budget/models/budget-model.ts